import React from 'react';
import { RoutineDurationExercise, RoutineRepetitionExercise } from '../../../types/Fisiofit/routine';

interface ExerciseDetailsProps {
  exercise: RoutineRepetitionExercise | RoutineDurationExercise;
}

export const ExerciseDetails = ({ exercise }: ExerciseDetailsProps) => {
  const isRepetitionExercise = (ex: RoutineRepetitionExercise | RoutineDurationExercise): ex is RoutineRepetitionExercise => {
    return 'repetitions' in ex && ex.repetitions !== undefined;
  };

  return (
    <div className='exercise-form-fields read-only-fields'>
      <div className='exercise-field-info'>
        <h5 className='field-label'>Ejercicio</h5>
        <div className='field-value exercise-name-value'>{exercise.name}</div>
      </div>

      <div className='exercise-data-grid'>
        {exercise.sets && (
          <div className='exercise-field-info'>
            <h5 className='field-label'>Series</h5>
            <div className='field-value'>{exercise.sets}</div>
          </div>
        )}

        {isRepetitionExercise(exercise) && exercise.repetitions !== undefined && (
          <div className='exercise-field-info'>
            <h5 className='field-label'>Repeticiones</h5>
            <div className='field-value'>{exercise.repetitions}</div>
          </div>
        )}

        {!isRepetitionExercise(exercise) && exercise.duration !== undefined && (
          <div className='exercise-field-info'>
            <h5 className='field-label'>Tiempo (s)</h5>
            <div className='field-value'>{exercise.duration}</div>
          </div>
        )}

        {exercise.weight !== undefined && (
          <div className='exercise-field-info'>
            <h5 className='field-label'>Peso (kg)</h5>
            <div className='field-value'>{exercise.weight}</div>
          </div>
        )}

        {exercise.rir !== undefined && (
          <div className='exercise-field-info'>
            <h5 className='field-label'>RIR</h5>
            <div className='field-value'>{exercise.rir}</div>
          </div>
        )}

        {exercise.rpe !== undefined && (
          <div className='exercise-field-info'>
            <h5 className='field-label'>RPE</h5>
            <div className='field-value'>{exercise.rpe}</div>
          </div>
        )}
      </div>

      {exercise.comment && (
        <div className='exercise-field-info comment-field'>
          <h5 className='field-label'>Comentario</h5>
          <div
            className='field-value comment-value'
            ref={(el) => {
              if (el) {
                // Añadir clase has-overflow si el contenido es más alto que el contenedor
                const hasOverflow = el.scrollHeight > el.clientHeight;
                if (hasOverflow) {
                  el.classList.add('has-overflow');
                } else {
                  el.classList.remove('has-overflow');
                }
              }
            }}
          >
            «{exercise.comment}»
          </div>
        </div>
      )}
    </div>
  );
};
